import React from "react";
import useGetNowPlayingMovies from "../hooks/useGetNowPlayingMovies";
import { VideoInfo } from "./VideoInfo";
import { VideoBackground } from "./VideoBackground";

export const MainContainer = () => {
  useGetNowPlayingMovies();
  return (
    <>
      <VideoInfo />
      <VideoBackground />
    </>
  );
};
